var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserMultipleFemaleGroup = function SvgUserMultipleFemaleGroup(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.978,22.913l.659-3.956h2.638L15.3,13.023c-.66-1.978-1.476-3.3-3.3-3.3s-2.637,1.318-3.3,3.3L6.725,18.957H9.363l.659,3.956Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 5.771,
    r: 2.637
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.25,14.587H21l.45-2.7h1.8L21.9,7.837c-.45-1.35-1.007-2.25-2.25-2.25s-1.8.9-2.25,2.25l-.267.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 19.65,
    cy: 2.887,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.75,14.587H3l-.45-2.7H.75L2.1,7.837c.45-1.35,1.007-2.25,2.25-2.25s1.8.9,2.25,2.25l.267.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.35,
    cy: 2.887,
    r: 1.8
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserMultipleFemaleGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "user-multiple-female-group.5dbfb7b63ffb43d56eb8fcf38a2703a6.svg";